export const REQUIRED_FIELD = {
  mobile: [
    'SuperAdmin',
    'HsAdmin',
    'Doctor',
    'CA',
    'TeleFITSuperAdmin',
    'TeleFITAdmin',
    'Manager',
    'TeleFITStudio',
    'CSO',
    'MHS',
    'Staff',
    'LabAdmin',
  ],
  imageUrl: ['Doctor'],
  mcr: [],
  clinicId: [],
  praticisingCertificate: [],
  lstClinicId: ['CA'],
  lstCertificates: ['Trainer'],
};
